export const DB_ENUMS = {
    CURRENT_CREDIT_SCORE: ["N/A", "< 620", "621-640", "641-660", "661-680", "681-700", "701-720", "721-740", "> 740"],
    CURRENT_MONTHLY_INCOME: ["No Income", "$1k-$5k", "$5k-$10k", "$10k-$50k", ">50k"],
    PROGRAMS: ["Buyer Program", "Seller Program", "Mortgage Program", "Refinancing Program", "Tradelines"],
    CREDIT_CARDS: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    MESSAGE_TYPE: ["sms", "email"],
    MESSAGE_TYPE_BOTH: ["sms", "email", "both"],
    CONTACT_TYPE: ["user", "credit_lead", "credit_client", "restate_lead", "restate_client"],
    CRUD_TYPE: ["create", "read", "update", "delete"],
    ACTIVITY_ACTION: ["create", "edit", "delete"],
    ACTIVITY_TYPE: ["message", "group", "task", "appointment", "campaign", "lead", "client", "bulk-message"],
    ACTIVITY_TABS: [
        "OVERALL",
        "DOCUMENTS",
        "NOTES",
        "FINANCIAL DISCLOSURE",
        "APPOINTMENTS",
        "TASKS",
        "PROGRAMS",
    ],
    STATUS_PENDING: ["Contact", "Agent"],
    SOURCE_TYPE: [
        "facebook",
        "twitter",
        "realestatelane_website",
        "creditclubrepair_website",
        "MANUAL",
        "phone",
        "email",
        "instagram",
        "tiktok",
    ],
    STATUS_TYPE: [
        "Business Associate",
        "Cold Lead",
        "Competitor",
        "Consultant",
        "Contractor",
        "Co-Worker",
        "Customer",
        "Decision Maker",
        "Distributor",
        "Employee",
        "Family",
        "Friend",
        "Gate Keeper",
        "Hot Lead",
        "Influencer",
        "Investor",
        "Key Customer",
        "Lead",
        "Manufacturer",
        "Personal",
        "Prospect",
        "Qualified Lead",
        "Reseller",
        "Retailer",
        "Shareholder",
        "Supplier",
        "Vendor",
        "Warm Lead",
        "Wholesaler",
    ],
    GOAL_TYPE: [""],
    LEGAL_STATUS: ["married", "single"],
    CLASS_CERT: ["1st", "2nd"],
    OWN_RENT: ["own", "rent"],
    INSURANCE_TYPE: ["home", "rent"],
    CARRIER_TYPE: ["own", "rent"],
    EMPLOYEE_TYPE: ["w2", "1099"],
    PRIORITY_TYPE: ["Highest", "High", "Medium", "Low"],
    APPOINTMENT_TYPE: ["lead_appointment", "client_appointment"],
    GROUP_STATUS: ["active", "no_active"],
    MESSAGE_TYPE_DROPDOWN: [
        { value: "sms", label: "sms" },
        { value: "email", label: "email" },
    ],
    CONTACT_TYPE_DROPDOWN: [
        { value: "lead", label: "Lead" },
        { value: "client", label: "Client" },
        { value: "both", label: "Both" },
    ],
    CONTACT_TYPE_CAMPAIGN: [
        "lead",
        "client",
        "both"
    ],
    MESSAGE_TYPE_BOTH_DROPDOWN: [
        { value: "sms", label: "Text Message" },
        { value: "email", label: "Email" },
        { value: "both", label: "Both" },
    ],
    RED_FLAG: ["true", "false"],
    CONTACTED: ["true", "false"],
    CALENDAR_FILTER: ["All", "Tasks", "Appointments"],
    PAYMENT_OPTIONS: [
        { value: 0, label: 'Paid in full' },
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 },
        { value: 6, label: 6 },
        { value: 8, label: 8 },
        { value: 9, label: 9 },
        { value: 12, label: 12 },
        { value: 18, label: 18 },
        { value: 24, label: 24 },
    ],
    YES_NO: [
        { value: "true", label: 'Yes' },
        { value: "false", label: 'No' },
    ],
    LOAN_TERMS: [
        "15 Years",
        "20 Years",
        "25 Years",
        "30 Years",
        "40 Years",
        "5/1 ARM",
        "7/1 ARM",
        "10/1 ARM",
        "3/1 ARM",
        "10-Year Balloon Mortgage",
        "15-Year Balloon Mortgage",
    ],
    BUYING_TIMELINE: [
        "Immediatley", // Today - +30 dias
        "1-3 months", // Day X - Day Y
        "4-6 Months", // Day X - Day Y
        "7-9 Months", // Day X - Day Y
        "9-12 Months", // Day X - Day Y
        "+12 Months", // +1 Year - +1 Year + 4 Months
    ],
    REFINANCING_GOALS: [
        "Lower Monthly Payments",
        "Reduce Interest Rate",
        "Shorter Loan Term",
        "Consolidating Debt",
        "Accessing Home Equity (Cash-Out)",
        "Switch from Adjustable to Fixed Rate",
        "Lower Mortgage Insurance",
        "Remove a Co-Borrower",
    ],
    LOAN_TYPE: [
        "Fixed-rate Mortgage",
        "Adjustable-rate Mortgage (ARM)",
        "Interest-only Mortgage",
        "FHA Loan",
        "VA Loan",
        "USDA Loan",
        "Conventional Loan",
        "Jumbo Loan",
        "Balloon Mortgage",
        "Reverse Mortgage",
    ],
    INTEREST_RATE_TYPE: [
        "Fixed Rate",
        "Variable Rate",
        "Adjustable Rate",
        "Hybrid Rate",
        "Teaser Rate",
        "Discounted Rate",
        "Prime Rate",
        "Subprime Rate",
        "Cap Rate",
        "Floor Rate",
    ],
    EMPLOYMENT_STATUS: [
        "W2",
        "1099",
        "Selfemployed",
        "Unemployed"
    ],
    PROPERTY_TYPE: [
        "Residential",
        "Rental",
        "Mobilehome",
        "Condominium",
        "Multifamily",
        "Commercial",
        "Land",
        "Farm"
    ],
    PROPERTY_SPECIAL_REQUIREMENTS: [
        "Pool",
        "Garage",
    ],
    ALL_PROGRAMS: [
        "Buyer",
        "Seller",
        "Mortgage",
        "Refinancing",
        "Tradelines"
    ],
    HELP_WITH_OPTIONS: [
        "Credit",
        "Taxes",
        "Downpayment",
        "Closing Costs",
        "Downpayment + Closing Costs",
    ]
};
